import { render, staticRenderFns } from "./UserGroupTree.vue?vue&type=template&id=91dad010&scoped=true&"
import script from "./UserGroupTree.vue?vue&type=script&lang=js&"
export * from "./UserGroupTree.vue?vue&type=script&lang=js&"
import style0 from "./UserGroupTree.vue?vue&type=style&index=0&id=91dad010&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91dad010",
  null
  
)

export default component.exports